import sliderLayoutController from '../global/sliderLayoutController';

const testimonialSlider = () => {
	const testimonialSliders = Array.from(document.querySelectorAll(".testimonial-slider:not(.success-stories)"));
    
	if (testimonialSliders.length > 0) {
		sliderLayoutController('testimonial-slider__slides-container', null, "fade", null, '.testimonial-slider__prev', '.testimonial-slider__next');
	}
}

export default testimonialSlider;
